var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB0C6771-B2EE-4DC5-96AB-5666D2256238") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.03---Document-verify-vertical",
    transform: "translate(-300.000000, -328.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ico-zoom",
    transform: "translate(294.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5000011,12 L13.0000011,12 L13.0000011,9.5 C13.0000011,9.224 12.7760011,9 12.5000011,9 C12.2240011,9 12.0000011,9.224 12.0000011,9.5 L12.0000011,12 L9.5000011,12 C9.2240011,12 9.0000011,12.224 9.0000011,12.5 C9.0000011,12.776 9.2240011,13 9.5000011,13 L12.0000011,13 L12.0000011,15.5 C12.0000011,15.776 12.2240011,16 12.5000011,16 C12.7760011,16 13.0000011,15.776 13.0000011,15.5 L13.0000011,13 L15.5000011,13 C15.7760011,13 16.0000011,12.776 16.0000011,12.5 C16.0000011,12.224 15.7760011,12 15.5000011,12 M16.4630011,16.458 C16.4620011,16.458 16.4610011,16.458 16.4600011,16.459 C16.4590011,16.46 16.4590011,16.462 16.4580011,16.463 C15.4110011,17.508 14.0210011,18.084 12.5420011,18.084 L12.5410011,18.084 C11.0610011,18.084 9.6690011,17.508 8.6230011,16.461 C7.5760011,15.415 7.0000011,14.023 7.0000011,12.542 C7.0000011,11.062 7.5760011,9.67 8.6230011,8.624 C9.6690011,7.577 11.0610011,7 12.5420011,7 C15.5970011,7 18.0830011,9.486 18.0830011,12.542 C18.0830011,14.021 17.5080011,15.411 16.4630011,16.458 M21.8530011,21.146 L17.5020011,16.795 C18.4850011,15.65 19.0830011,14.165 19.0830011,12.542 C19.0830011,8.935 16.1470011,6 12.5410011,6 C10.7930011,6 9.1500011,6.681 7.9150011,7.917 C6.6800011,9.152 5.9990011,10.795 6,12.542 C6,14.29 6.6800011,15.933 7.9160011,17.168 C9.1510011,18.404 10.7940011,19.084 12.5410011,19.084 L12.5420011,19.084 C14.1660011,19.084 15.6500011,18.485 16.7950011,17.502 L21.1460011,21.854 C21.2440011,21.951 21.3720011,22 21.5,22 C21.6270011,22 21.7550011,21.951 21.8530011,21.854 C22.0480011,21.658 22.0480011,21.342 21.8530011,21.146",
    id: "Ico"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/Zoom.ed94b97d4f8d6111fde04982c0673198.svg";
export { ForwardRef as ReactComponent };